const Vue = window.Vue;

Vue.component('EnergyLabelButton', () => import('./app/components/EnergyLabelButton.vue'));
Vue.component('DatasheetButton', () => import('./app/components/DatasheetButton.vue'));
Vue.component('EnergyDatasheetLink', () => import('./app/components/EnergyDatasheetLink.vue'));

Vue.filter('basketVariationProperties', function (basketItem) {
  const exlcudedVariationProperties = EnergyLabelConfig.global.excludeVariationProperties.split(',').map(item => item.trim());

  if (exlcudedVariationProperties.length > 0) {
    if (basketItem && basketItem.variation && basketItem.variation.data && basketItem.variation.data.variationProperties &&
      !basketItem.variation.data.hasOwnProperty('fullVariationProperties')) {
      basketItem.variation.data.fullVariationProperties = JSON.parse(JSON.stringify(basketItem.variation.data.variationProperties));
      basketItem.variation.data.variationProperties.map(propertyGroup => {
        propertyGroup.properties = propertyGroup.properties.filter(prop => !exlcudedVariationProperties.includes('' + prop.id));
        return propertyGroup;
      });
    }
  }
  return basketItem;
});

$(function () {
  if (!App.isShopBuilder) {
    // Fix for lastSeen containers
    setInterval(function () {
      $(' .cmp-product-thumb .thumb-meta energy-label-button').each(function () {
        $(this).parent().before(this);
        const newThis = $(this).parent().find('energy-label-button');

        if (newThis.length > 0) {
          new Vue({
            el: newThis[0],
            store: window.ceresStore
          });
        }
      });
    }, 500);

    // Fix for order details
    setInterval(function () {
      $('.modal .confirmation-order-list energy-label-button').each(function () {
        new Vue({
          el: $(this)[0],
          store: window.ceresStore
        });
      });
      $('.modal .confirmation-order-list datasheet-button').each(function () {
        new Vue({
          el: $(this)[0],
          store: window.ceresStore
        });
      });
    }, 500);
  }
});
